import React, { useEffect, useState } from 'react';

// Объявление о завершении загрузки для скринридера.
//
// Зачем отдельный узел, а не role="status" на самом контейнере результата:
// живой регион зачитывает ВСЁ, что в него добавилось. Повесив его на таблицу,
// мы бы диктовали пользователю все пятьсот строк подряд вместо «Users loaded».
// Поэтому текст здесь короткий и рукописный, а сам регион — визуально скрытый
// и пустой большую часть времени.
//
// Регион обязан присутствовать в DOM ДО того, как изменится его текст: узел,
// вставленный уже с текстом, большинство скринридеров не объявляет. Отсюда
// компонент рендерится всегда, а пустеет через состояние, а не через размонтаж.
//
// polite, а не assertive: загрузка отчёта не настолько срочна, чтобы прерывать
// человека на полуслове.
const LoadingAnnouncer = ({ loading, label, loadedLabel }) => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (loading) {
      setMessage(`${label}…`);
      return undefined;
    }
    // Пустая строка на первом рендере (загрузка ещё не начиналась) объявления
    // не даёт — и не должна: сообщать «загружено» до того, как что-то грузили,
    // значит врать.
    setMessage((current) => (current ? loadedLabel : ''));

    // Сообщение снимается, иначе повторная загрузка того же экрана не изменит
    // текст региона и не будет объявлена вовсе.
    const timer = setTimeout(() => setMessage(''), 2000);
    return () => clearTimeout(timer);
  }, [loading, label, loadedLabel]);

  return (
    <div role="status" aria-live="polite" className="sr-only">
      {message}
    </div>
  );
};

export default LoadingAnnouncer;
